export default [
  {
    path: "/fydata",
    name: "fydata",
    meta: {
      bgType: 1,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/scenicSpotBigData/fyifame.vue"
      ),
  },
  {
    path: "/wlys",
    name: "wlys",
    meta: {
      bgType: 1,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/scenicSpotBigData/wlys.vue"
      ),
  },
  {
    path: "/culturalTourismProject",
    name: "culturalTourismProject",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/culturalTourismSituation/culturalTourismProject.vue"
      ),
    meta: {
      bgType: 1,
    },
  },
  {
    path: "/trafficCheckpoint",
    name: "trafficCheckpoint",
    meta: {
      bgType: 1,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/culturalTourismSituation/trafficCheckpoint.vue"
      ),
  },
  {
    path: "/hotel",
    name: "hotel",
    meta: {
      bgType: 1,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/culturalTourismSituation/hotel.vue"
      ),
  },
  {
    path: "/intangibleHeritage",
    name: "intangibleHeritage",
    meta: {
      bgType: 1,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/culturalTourismSituation/intangibleHeritage.vue"
      ),
  },
  {
    path: "/oldTree",
    name: "oldTree",
    meta: {
      bgType: 1,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/culturalTourismSituation/oldTree.vue"
      ),
  },
  {
    path: "/culturalRelic",
    name: "culturalRelic",
    meta: {
      bgType: 1,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/culturalTourismSituation/culturalRelic.vue"
      ),
  },
  {
    path: "/video",
    name: "video",
    meta: {
      bgType: 1,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/culturalTourismSituation/video.vue"
      ),
  },
  {
    path: "/globalBigData",
    name: "globalBigData",
    meta: {
      bgType: 3,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/global/globalBigData.vue"
      ),
  },
  {
    path: "/touristPortrait",
    name: "touristPortrait",
    meta: {
      bgType: 3,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/global/touristPortrait.vue"
      ),
  },
  {
    path: "/touristConsumption",
    name: "touristConsumption",
    meta: {
      bgType: 3,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/global/touristConsumption.vue"
      ),
  },
  {
    path: "/wisdomQingChengShan",
    name: "wisdomQingChengShan",
    meta: {
      bgType: 3,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/global/wisdomQingChengShan.vue"
      ),
  },
];
